import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import StakingDashboard from '../../screens/Staking';
import StakingFeatures from '../../screens/Staking/Features';
import StakingPromo from '../../screens/Staking/Promo';

const StakingRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/`}>
        <Redirect to={`${path}/promo`} />
      </Route>
      <Route exact path={`${path}/promo`}>
        <StakingPromo />
      </Route>
      <Route exact path={`${path}/features`}>
        <StakingFeatures />
      </Route>
      <Route exact path={`${path}/:stakingType`}>
        <StakingDashboard />
      </Route>
    </Switch>
  );
};

export default StakingRouter;
